import { useContext } from 'react';

import SeedFailedOrdersContext from './SeedFailedOrdersContext';

const useSeedFailedOrders = () => {
  return useContext(SeedFailedOrdersContext);
};

export default useSeedFailedOrders;
